<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 219px;
  margin-top: 20px;

  .plane {
    // padding-top: 5px;

    .energy {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
      padding: 0 20px;

      .ene_data {
        height: 112px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        p:nth-child(1) {
          font-size: 18px;
        }

        p:nth-child(2) {
          font-size: 46px;
          font-family: "dina";

          // &::after{
          //   position: absolute;
          //   right: 0;
          //   content: '';
          //   width: 8.6px;
          //   height: 7.5px;
          //   // border: 1px solid red;
          //   background-image: url('../../../../../assets/compImg/icon/Triangular2.png');
          //   background-size: cover;
          // }
          img {
            width: 8.66px;
            height: 7.5px;
            position: absolute;
            top: 114px;
            margin-left: 6px;
          }
          .end{
            width: 10px;
            height: 3px;
          }
        }

        p:nth-child(3) {
          font-family: "dina";
          font-size: 18px;
          color: #C4C4C4;
        }
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane title="能耗管理" class="plane"
      :iconImg="require('@/assets/compImg/icon/energy.png')">
      <div class="energy">
        <div v-for="(item, index) in energy" :key="index" class="ene_data">
          <P>{{ item.title }}</P>
          <P>{{ item.eneData }}<img :src="item.imgs" :class="{end:index==2}" alt=""></P>
          <P>{{ item.company }}</P>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
export default {
  data() {
    return {
    }
  },
  props:{
    energy:Array
  }
}
</script>